


import axiosInstance from "../config";

export const userProfileService = async (data, token) => {

  try {


    const response = await axiosInstance.post('/admin_app/user_profile', data ,
          {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })

    


    return {
      success: true,
      data: response.data,
      status: response.status,

    };


  }
  catch (error) {

    return {
      success: false,
      message: error.response?.data?.message || "Login failed",
      status: error.response?.status || 500,
      errors: error.response?.data?.errors || null,


    };

  }


}



